/* Jonathan - Custom JS */
'use strict';

var enableUnitOfMeasure = true; 
var enableAutoOpenProductDetails = true;
var enablehideEmptyDescription = true;
var enableCartShareLinkDeleteCartItem = false;
var enableQtyMinMaxCheck = true;
var enableQtyMinMaxCheckEvents = true;
var enableCartCSR = false;

var activeQtyBox = null;

////////////////////////////////////////////////////////////////
// wait for when itoris option fields are ready in the dom
/*function waitForElm(selector, disconnect) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) return resolve(document.querySelector(selector));
        const observer = new MutationObserver(mutations => { if (document.querySelector(selector)) { resolve(document.querySelector(selector)); if (disconnect === true) observer.disconnect() } });
        observer.observe(document.body, { childList: true, subtree: true })
    })
}*/

// top-header-panel
for (var topHeaderPanel of document.querySelectorAll("section.shopify-section-group-header-group #top-panel-header")) {
    $q(topHeaderPanel.closest("section.shopify-section-group-header-group.cc-custom-liquid")).addClass("has-top-panel-header");
}

//if(document.querySelector(".cc-cart-drawer cart-drawer .cart-empty") !== null){
  //document.body.classList.add("has-empty-cart");
//}

// add html class if product has custom options (itoris)
//waitForElm('html.is-products #itoris_dynamicproductoptions', true).then((elm) => {
$q('html.is-products #itoris_dynamicproductoptions').wait(true,(elm) => {
  //if(document.querySelector("html.is-products .dpo-container") !== null){
     $q(document.documentElement).addClass("has-custom-options");
  //}
});

// listen for add to cart
document.addEventListener('on:cart:add', (event) => {
    if(document.querySelector(".cc-cart-drawer cart-drawer .cart-empty") !== null){
      document.body.classList.add("has-empty-cart");
    }
  
    if(document.querySelector("body.has-empty-cart") !== null){
        document.body.classList.remove("has-empty-cart");
    }
});

////////////////////////////////////////////////
// wait for cat-share-link
if(enableCartShareLinkDeleteCartItem == true){

    $q('html.is-cart.q-is-loaded .cart-share-link').wait(true,(elm) => {

        // remove sessionStorage item 'selectedVariantID'
        sessionStorage.removeItem('selectedVariantID');

        // bind click handler on cart share link 
        document.querySelector('#cart').addEventListener('click', (e) => {

        const link = e.target.closest('.cart-share-link');
        if (!link) return; // not a share link → ignore

        e.preventDefault();

        const parentItem = link.closest('.cart-item');
        const variantID = parentItem?.dataset.variantId;
        if (!variantID) {
            //console.warn('No data-variant-id found for cart item');
            return;
        }

        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', variantID);
        link.href = url.toString();

        // Store variantID in sessionStorage
        sessionStorage.setItem('selectedVariantID', variantID);
        window.location.href = link.href;
        });
    });
}

//////////////////////////////////
// sample in cart check
document.addEventListener('on:cart:add', (event) => {
  if(document.querySelector("html.is-products.is-sample-product") !== null){
    sampleProductCartCheck();
  } else {
    sampleButtonCartCheck();
  }
  if(window.console){ console.log("line-item-add"); }
});

document.addEventListener('on:line-item:change', (event) => {
  if(document.querySelector("html.is-products.is-sample-product") !== null){
    sampleProductCartCheck();
  } else if(document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null) {
    sampleButtonCartCheck();
  }
  if(window.console){ console.log("line-item-change"); }
});

function sampleButtonCartCheck(){

  setTimeout(function(){
  
    let sampleFormBox = document.querySelector(".sample-form-box");
    if(sampleFormBox !== null && (document.querySelector("html.is-products") !== null || document.querySelector("html.is-collections") !== null || document.querySelector("html.search") !== null)){
      
    	let sampleButton = sampleFormBox.querySelector("button.button-sample");
    	let sampleVariantID = sampleFormBox.querySelector(".product-info__add-button-sample").dataset.variantId;
    	let hasSampleInCart = false;
        let sampleCountLimit = false;
        let samplePrice = sampleButton.dataset.samplePrice;
    	let sampleButtonText = "Add " + samplePrice + " Sample";
        let sampleCount = 0;
    	for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
        	// data-variant-id="46251452170462"
            let productTitle = cartItem.querySelector('.cart-item__title').textContent;
            if(productTitle.indexOf("Sample of") != -1){
              sampleCount++;
            }
        	let variantID = cartItem.dataset.variantId;
    		if(sampleVariantID == variantID){
    			hasSampleInCart = true;
    			sampleButtonText = "Sample in Cart";
    		}
            if(sampleCount == 10){
              sampleCountLimit = true;
            }
    	}
        //console.log("sampleCount",sampleCount);
        //console.log("sampleCountLimit",sampleCountLimit);
    
    	if(hasSampleInCart == true){
    		sampleButton.setAttribute("disabled",true);
    	} else {
    		sampleButton.removeAttribute("disabled");
    	}

        if (sampleCountLimit == true){
          sampleButtonText = "Max Limit of 10 Samples in Cart";
          sampleButton.setAttribute("disabled",true);
        }
          
    	sampleButton.textContent = sampleButtonText;  
    }

  }, 1000);
}

function sampleProductCartCheck(){

  setTimeout(function(){

    //console.log("sampleProductCartCheck",sampleProductCartCheck);
  
    let sampleProductFormBox = document.querySelector("html.is-products.is-sample-product product-form form.js-product-form.js-product-form-main");
    if(sampleProductFormBox !== null && document.querySelector("html.is-products.is-sample-product") !== null){
      
    	let sampleButton = sampleProductFormBox.querySelector(".product-info__add-to-cart .product-info__add-button .btn.btn--primary");
    	let sampleVariantID = sampleProductFormBox.querySelector('input[type="hidden"][name="id"]').value;
        //console.log("sampleVariantID",sampleVariantID);
    	let hasSampleInCart = false;
        let sampleCountLimit = false;
        let samplePrice = sampleButton.dataset.samplePrice;
    	let sampleButtonText = "Add " + samplePrice + " Sample";
    	//let sampleButtonText = "Add To Cart";
        let sampleCount = 0;
    	for (var cartItem of document.querySelectorAll("#cart-items tr.cart-item")) {
        	// data-variant-id="46251452170462"
            let productTitle = cartItem.querySelector('.cart-item__title').textContent;
            if(productTitle.indexOf("Sample of") != -1){
              sampleCount++;
            }
        	let variantID = cartItem.dataset.variantId;
    		if(sampleVariantID == variantID){
    			hasSampleInCart = true;
    			sampleButtonText = "Sample in Cart";
    		}
            if(sampleCount == 10){
              sampleCountLimit = true;
            }
    	}
        //console.log("sampleCount",sampleCount);
        //console.log("sampleCountLimit",sampleCountLimit);
        //console.log("hasSampleInCart",hasSampleInCart);
    
    	if(hasSampleInCart == true){
    		sampleButton.setAttribute("disabled",true);
    	} else {
    		sampleButton.removeAttribute("disabled");
    	}

        if(sampleCountLimit == true){
          sampleButtonText = "Max Limit of 10 Samples in Cart";
          sampleButton.setAttribute("disabled",true);
        }
          
    	sampleButton.textContent = sampleButtonText;  
    }

  }, 1000);
}

if(document.querySelector("html.is-products.is-sample-product") !== null){
    document.querySelector("html.is-products.is-sample-product form.js-product-form.js-product-form-main .product-info__add-to-cart .btn.btn--primary").setAttribute("disabled",true);
    sampleProductCartCheck();
}

//waitForElm('html.is-products form.js-product-form.js-product-form-main [name="id"]', true).then((elm) => {
  //var variantID = document.querySelector('html.is-products form.js-product-form.js-product-form-main [name="id"]').value;
  //console.log("variantID: ",variantID);
//});

////////////////////////////////////////////////////////////////
// mediaCheck - https://github.com/sparkbox/mediaCheck/blob/main/src/mediaCheck.js
function mediaCheck(options) {
    if (typeof window.matchMedia === 'undefined' || !window.matchMedia('!').addListener) { throw new Error('No matchMedia support'); }

    function mqChange(mq, options) { if (mq.matches) { if (typeof options.entry === 'function') { options.entry(mq); } } else { if (typeof options.exit === 'function') { options.exit(mq); } } if (typeof options.both === 'function') { options.both(mq); } }

    function createListener() {
        let mq = window.matchMedia(options.media);
        mq.addListener(function() { mqChange(mq, options); });
        window.addEventListener('orientationchange', function() {
            mq = window.matchMedia(options.media);
            mqChange(mq, options);
        }, false);
        mqChange(mq, options);
    }
    createListener();
}

////////////////////////////////////////////////////////////////
// add product-info__block helper class identifier
// wait and listen for element exists in DOM to work with
for (var colorways of document.querySelectorAll(".colorways-related-product-swatches.collection-products")) {
    //colorways = document.querySelector(".colorways-related-product-swatches");
    //colorways.closest(".product-info__block").classList.add("has-colorways");
    $q(colorways.closest(".product-info__block")).addClass("has-colorways");
}
if(document.querySelector("html.is-products .has-colorways") !== null && document.querySelector("html.is-products .has-colorways .colorways-related-product-swatches ul li") === null){
  	document.querySelector(".has-colorways").style.display = "none";
}

for (var relatedWidths of document.querySelectorAll(".related-fabric-widths.collection-products")) {
    $q(relatedWidths.closest(".product-info__block")).addClass("has-related-widths");
}
for (var outOfStock of document.querySelectorAll(".product-info .out-of-stock-disco")) {
    $q(document.documentElement).addClass("is-out-of-stock");
}
for (var customAccordion of document.querySelectorAll(".product-info .custom-accordion")) {
    let accordionType = customAccordion.dataset.accordionType;
    //console.log(accordionType);
    if (accordionType === "cleaning-care" || accordionType === "warranty" || accordionType === "delivery-shipping" || accordionType === "boxcushion") {
        //customAccordion.closest(".product-info__block").classList.add("has-"+accordionType);
        $q(customAccordion.closest(".product-info__block")).addClass("has-" + accordionType);
    }
}
// product label (NOT product page)
for (var catCustomProductThemeLabel of document.querySelectorAll("product-card .product-label-container .product-label.product-label--custom")) {
    $q(catCustomProductThemeLabel.closest(".card__media")).addClass("has-custom-product-theme-label");
    $q(catCustomProductThemeLabel.parentElement).addClass("parent-of-custom-product-theme-label");
    //catCustomProductThemeLabel.closest(".product-label-container").style.display = "none";
}
// // product label (ONLY product page) - only loop through first variant product label
for (var customProductThemeLabel of document.querySelectorAll(".product-info > variant-label.product-info__block .variant-label.js-variant-label:first-child .product-label.product-label--custom")) {
    // product-label--sale  --  .product-label-container
    if (customProductThemeLabel.closest("variant-label.product-info__block").querySelector(".product-label product-label--sale") !== null) {
        customProductThemeLabel.style.display = "none";
    } else {
        customProductThemeLabel.closest("variant-label.product-info__block").style.display = "none";
    }
}
// add has images class if megamenu uses image collection for submenu nav image 
for (var megaMenu of document.querySelectorAll("main-menu.main-menu ul.main-nav .main-nav__child.mega-nav.mega-nav--sidebar.has-motion")) {
    if (megaMenu.querySelector(".main-nav__grandchild li a div.media img") !== null) {
        $q(megaMenu).addClass("has-menu-images");
    }
}

for (var relatedWidths of document.querySelectorAll("html.is-products #paypalCreditBadge")) {
    $q(relatedWidths.closest(".product-info__block")).addClass("has-paypal-credit");
}

// only run if product page
if (document.querySelector("html.is-products") !== null) {

    // hide empty description
    if (enablehideEmptyDescription === true) {

        $q(document.documentElement).addClass("hide-empty-description");
        for (var descriptionContent of document.querySelectorAll(".disclosure__content.product-description")) {
            //console.log(descriptionContent.innerHTML.length);
            if (descriptionContent.textContent.trim().length > 0) {/* descriptionContent.innerHTML.length > 1 */
                $q(descriptionContent.closest("details-disclosure")).addClass("show-description");
                //$q(descriptionContent.closest("details-disclosure")).addClass(, "hide-description");
            }
        }
    } else {
        $q(document.documentElement).addClass("show-empty-description");
    }

    // add has-custom-options class to product-info__block
    if (document.querySelector(".product.js-product .product-info__block.product-options") !== null) {
        $q(document.documentElement).addClass("has-custom-options");
    }
    // add has-application class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block #application-icons-box")) {//#application-list
        $q(application.closest(".product-info__block")).addClass("has-application");
    }
    // add has-kit class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block #kit-list")) {
        $q(application.closest(".product-info__block")).addClass("has-kit");
    }
    // add has-minmaxify class to product-info__block
    for (var application of document.querySelectorAll(".product.js-product .product-info__block .minmaxify-product-limits")) {
        $q(application.closest(".product-info__block")).addClass("has-minmaxify");
    }
    // add has-review class to product-info__block
    //waitForElm('.product.js-product .product-info__block .yotpo-widget-instance', true).then((elm) => {
    $q('.product.js-product .product-info__block .yotpo-widget-instance').wait(true,(elm) => {
        $q(document.querySelector(".product-info__block .yotpo-widget-instance").closest(".product-info__block")).addClass("has-review");
    });
    // hide empty product backorder
    if (document.querySelector('.product-info__block.product-backorder [hidden=""].backorder') !== null) {
        document.querySelector('.product-info__block.product-backorder').style.display = "none";
    }

    //waitForElm('div[id*="__discount_depot_volume_table_"]', true).then((elm) => {
    $q('div[id*="__discount_depot_volume_table_"]').wait(true,(elm) => {
        if (document.querySelector('div[id*="__discount_depot_volume_table_"]') !== null) {
            let productInfoBlockVolumeTable = document.querySelector('div[id*="__discount_depot_volume_table_"]').closest(".product-info__block");
            $q(productInfoBlockVolumeTable).addClass("has-volume-table");
            if (document.querySelector('div[id*="__discount_depot_volume_table_"] p[style="display:none"]') !== null) {
                productInfoBlockVolumeTable.style.display = "none"
            }
        }
    });
}

////////////////////////////////////////////////////////////////
// cross browser and cross device helper classes
var winNav = window.navigator;
var UA = winNav.userAgent;
var isSafari = UA.match(/Safari/i) == "Safari";
var isMac = UA.match(/Macintosh/i) == "Macintosh";
var isTouchIpad = (UA.match(/iPad/i) == "iPad");
var isTouchIphone = (UA.match(/iPhone/i) == "iPhone");
var isTouch = window.matchMedia('(pointer: coarse)').matches;//'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;//(!!("undefined" != typeof document.documentElement.ontouchstart)) || (winNav.maxTouchPoints > 0);
var isFirefox = UA.match(/Firefox/i) == "Firefox";
var isChrome = UA.match(/Chrome/i) == "Chrome";
var isChromium = window.chrome;
var vendorName = winNav.vendor;
var isOpera = typeof window.opr !== "undefined";
var isIEedge = UA.indexOf("Edge") > -1;
var isIOSChrome = UA.match("CriOS");
var browserVersion = UA.match(/Version\/(.*)$/);
var html = document.documentElement;

function setBrowserHelperClasses() {

    if (isSafari) {
        $q(html).addClass("is-safari");
    }
    if (browserVersion !== null) {
        var isSafari13 = (isSafari && browserVersion[0].indexOf("13") !== -1);
        if (isSafari13) {
            $q(html).addClass("safari-13");
        }
    }
    if (isMac) {
        $q(html).addClass("is-mac");
    }
    if (isTouchIpad) {
        $q(html).addClass("is-ipad");
    }
    if (isTouchIphone) {
        $q(html).addClass("is-iphone");
    }
    if (isFirefox) {
        $q(html).addClass("is-firefox");
    }
    // Check if google chrome
    if (isIOSChrome) {
        // is Google Chrome on IOS
        $q(html).addClass("is-chrome-ios");
    } else if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
        // is Google Chrome 
        $q(html).addClass("is-chrome");
    } else {
        // not Google Chrome
        $q(html).addClass("not-chrome");
    }
}
setBrowserHelperClasses();

function touchClass() {

    if (isTouch === true) {
        $q(html).removeClass("touch-no");
        $q(html).addClass("touch");
        if (isTouchIpad == true) {
            $q(html).addClass("touch-ipad");
        } else {
            $q(html).removeClass("touch-ipad");
        }
        var nua = navigator.userAgent
        var isSilkBrowser = UA.indexOf("Silk") !== -1;
        if (isSilkBrowser) {
            $q(html).addClass("silk");
        } else {
            $q(html).removeClass(html, "silk");
        }
    } else {
        $q(html).removeClass("touch");
        $q(html).addClass("touch-no");
    }
}
touchClass();

/////////////////////////////////////////////
// check orientation
function checkOrientation(isMobile) {

    //alert(navigator.userAgent);
    if (isMobile) {
        if (window.matchMedia("(orientation: landscape)").matches) {
            $q(html).removeClass("portrait");
            $q(html).addClass("landscape");
        } else if (window.matchMedia("(orientation: portrait)").matches) {
            $q(html).removeClass("landscape");
            $q(html).addClass("portrait");
        }
    }
}

/////////////////////////////////////////////
// how to use mediaCheck method
mediaCheck({
    media: '(min-width: 768px)',
    // Switch to Desktop Version
    entry: function() {
        // The function that toggles page elements from desktop to mobile mode is called here
        $q(html).removeClass("mobile");
        $q(html).addClass("desktop");
        touchClass();
        checkOrientation(false);
        if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
          if(document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").hasAttribute("open") == false) {
            // disclosure disclosure--row
            document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").setAttribute("open","");
          }
        }
        //console.log("mediaCheck: (min-width: 768px) - entry");
    },
    // Switch to Mobile Version
    exit: function() {
        // The function that toggles page elements from mobile to desktop mode is called here
        $q(html).removeClass("desktop");
        $q(html).addClass("mobile");
        touchClass();
        checkOrientation(true);
        if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
          if(document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").hasAttribute("open")) {
            // disclosure disclosure--row
            document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").removeAttribute("open");
          }
        }
       // on mobile close description and specs product details disclosure row if open on load 
        if(document.querySelector("html.is-products") !== null) {
          for (var productDetailsDisclosureRow of document.querySelectorAll("html.is-products .product-details .disclosure.disclosure--row")) {
            if(productDetailsDisclosureRow.hasAttribute("open")) {
                productDetailsDisclosureRow.removeAttribute("open");
            }
          }
        }
        //console.log("mediaCheck: (min-width: 768px) - exit");
    }
});

/*let mql = window.matchMedia("(min-width: 768px)");
if(mql.matches){
  
} else {
  
}*/

////////////////////////////////////////////////////////////////
// get shopify handle and add as data attriute on html tag
function addHandleHelperClass() {

    if (document.querySelector("html.page-class-set") === null) {
        const url = new URL(window.location.href); //window.location.pathname;
        const getURLpathname = url.pathname;
        if (getURLpathname.indexOf("/collections/") !== -1 && getURLpathname.indexOf("/products/") === -1) {
            $q(document.documentElement).addClass("is-collections");
        } else if (getURLpathname.indexOf("/products/") !== -1) {
            $q(document.documentElement).addClass("is-products");
        } else if (getURLpathname.indexOf("/pages/") !== -1) {
            $q(document.documentElement).addClass("is-pages");
        } else if (getURLpathname.indexOf("/policies/") !== -1) {
            $q(document.documentElement).addClass("is-policies");
        } else if (getURLpathname.indexOf("/cart") !== -1) {
            $q(document.documentElement).addClass("is-cart");
        }
        if (getURLpathname === "\/") {
            $q(document.documentElement).addClass("is-home");
        } else {
            let lastSlash = getURLpathname.lastIndexOf("/");
            let shopifyHandle = getURLpathname.substring(lastSlash + 1);
            $q(document.documentElement).addClass(shopifyHandle);
        }
        //if(window.console) { console.log("html page-class-set via JS"); }
    }
}
addHandleHelperClass();

////////////////////////////////////////////////////////////////
// START - DOM loaded
document.addEventListener("DOMContentLoaded", (event) => {

    //if(window.console) { console.log("DOM fully loaded and parsed"); }

    ////////////////////////////////////////////////////////////////
    // open or close description and specs if desktop vs mobile
    if (enableAutoOpenProductDetails === true) {

        function autoOpenDetailsDisclosureRow(state) {

            if (typeof state == "undefined") {
                state = "close";
            }

            // details accordion will auto close for 1024px and below
            if (theme.mediaMatches.lg) {
                // product details (description and specs) - accordion
                for (var detailsDisclosureRow of document.querySelectorAll(".product-details__block details.disclosure.disclosure--row")) {
                    if (state === "open") {
                        detailsDisclosureRow.setAttribute("open", "");
                    } else if (state === "close") {
                        detailsDisclosureRow.removeAttribute("open");
                    }
                }
            }

            // related colorways collection - accordion
            // colorways accordion will always stay open for 1024px and below
            for (var hasColorwaysDisclosureRow of document.querySelectorAll(".product-info__block.has-colorways details.disclosure.disclosure--row")) {
                //if (window.matchMedia("(max-width: 600px)").matches) {
                if (hasColorwaysDisclosureRow.hasAttribute("open")) {
                    //hasColorwaysDisclosureRow.setAttribute("open","");
                } else {
                    hasColorwaysDisclosureRow.setAttribute("open", "");
                }
                //} else {
                //if(state === "open"){
                //hasColorwaysDisclosureRow.setAttribute("open","");
                //} else if(state === "close"){
                //hasColorwaysDisclosureRow.removeAttribute("open");
                //}
                //}
            }

            /**/
            if(window.matchMedia("(max-width: 768px)").matches){
              if(document.querySelector("html.is-products .product-info__block.has-colorways") !== null) {
                if(document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").hasAttribute("open")) {
                    document.querySelector("html.is-products .product-info__block.has-colorways .disclosure.disclosure--row").removeAttribute("open");
                } else {
                    document.querySelector("html.is-products .has-colorways .disclosure.disclosure--row").setAttribute("open","");
                }
              }
            }
        }
        //let mql = window.matchMedia("(min-width: 1025px)");
        //if(theme.mediaMatches.lg){//mql.matches
        //autoOpenDetailsDisclosureRow("open");
        //}
        if (theme.mediaMatches.lg) {
            autoOpenDetailsDisclosureRow("open");
        } else {
            autoOpenDetailsDisclosureRow("close");
        }
        //on:debounced-resize
        //on:breakpoint-change
        window.addEventListener('on:breakpoint-change', (event) => {
            //console.log(theme.mediaQueries);
            if (theme.mediaMatches.lg) {
                autoOpenDetailsDisclosureRow("open");
            } else {
                autoOpenDetailsDisclosureRow("close");
            }
        });
        /* theme.mediaQueries
        lg: "(min-width: 1024px)"
        md: "(min-width: 769px)"
        portrait: "(orientation: portrait)"
        sm: "(min-width: 600px)"
        xl: "(min-width: 1280px)"
        xxl: "(min-width: 1536px)"*/
    }

    // add unit of measure on product page
    if (enableUnitOfMeasure === true) {
        //waitForElm('.product-info__block.product-price .price__current', true).then((elm) => {
        $q('.product-info__block.product-price .price__current').wait(true,(elm) => {

            if (document.querySelector(".product-info__block.product-price .price__current") !== null) {
                if (document.querySelector(".product-sku") !== null) {
                    let unitOfMeasure = document.querySelector(".product-sku").dataset.unitOfMeasure;
                    document.querySelector(".product-info__block.product-price .price__current").dataset.unitOfMeasure = unitOfMeasure;
                }
            }
        });
    }

    // has sample button class
    //waitForElm('.product-info .product-info__add-to-cart .btn--primary', true).then((elm) => {
    $q('.product-info .product-info__add-to-cart .btn--primary').wait(true,(elm) => {

        // adds add to cart parent helper class for sticky - .closest(".product-info__block")
        let hasSampleClass = "";
        if (document.querySelector("button.btn.shopify-payment-button__button-sample") !== null) {
            document.querySelector("button.btn.shopify-payment-button__button-sample").parentElement.parentElement.parentElement.parentElement.classList.add("has-sample-button");
            hasSampleClass = "has-sample-button-sibling";
        }
        if (document.querySelector(".product-info__add-to-cart") !== null) {
            let addToCartButton = document.querySelector(".product-info__add-to-cart");
            addToCartButton.parentElement.parentElement.parentElement.classList.add("has-qty-add-to-cart-button");
            if (hasSampleClass !== "") {
                addToCartButton.parentElement.parentElement.parentElement.classList.add(hasSampleClass);
            }
        }

        //if(document.querySelector("button.btn.shopify-payment-button__button-sample") !== null){
        // document.querySelector("button.btn.shopify-payment-button__button-sample").parentElement.parentElement.classList.add("has-sample-button");
        //}
    });

    // add chevron svg icon to CTA button in header for contuct us dropdown
    /* //waitForElm('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button', true).then((elm) => {
    $q('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button').wait(true,(elm) => {

        let svgChevronDownIcon = '<svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="svg--toggle-icon icon"><path d="M20 8.5 12.5 16 5 8.5" stroke="currentColor" stroke-width="1.5" fill="none"></path></svg>';
        let ctaButton = document.querySelector('header.header__grid .secondary-nav__item.secondary-nav__cta.secondary-nav__cta--button');
        ctaButton.insertAdjacentHTML('beforeend', svgChevronDownIcon);
    });*/

    /////////////////////////////////////////////////
    //  email signup exists message
    //waitForElm('pop-up .modal__window form input[id*="-sign-up"]', true).then((elm) => {
    /*$q('pop-up .modal__window form input[id*="-sign-up"]').wait(true,(elm) => {

        // document.querySelector('pop-up .modal__window form input[id*="__pop_up_"][id*="-sign-up"]')
        // document.querySelector('popup .modal__window form input[id*="-sign-up"]') 
        //if(document.querySelector("pop-up .modal__window form input[id*="__pop_up_"][id*="-sign-up"])){

        //if(window.console){ console.log("pop up"); }

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        if (urlParams.has("contact_posted") && window.location.href.search("[?&]contact_posted=true") != -1 && window.location.href.search("-sign-up_form") != -1) {

            //if(window.console){console.log("is popup sign up form submitted");}
            if (document.querySelector(".alert.bg-success-bg.text-success-text") !== null) {
                //if(window.console){console.log("popup form success");}
            } else {
                //if(window.console){console.log("popup form NOT success");}
                // add fake message email exists insert into dom
                if (document.querySelector('pop-up .modal__window form input[id*="-sign-up"]').value !== "") {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                } else {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                }
            }

        } else if (urlParams.has("form_type") && window.location.href.search("[?&]form_type=customer") != -1 && window.location.href.search("-sign-up_form") != -1) {

            //if(window.console){console.log("is popup sign up form submitted");}
            if (document.querySelector(".alert.bg-success-bg.text-success-text") !== null) {
                // if(window.console){console.log("popup form success");}
            } else {
                //if(window.console){console.log("popup form NOT success");}
                // add fake message email exists insert into dom
                if (document.querySelector('pop-up .modal__window form input[id*="-sign-up"]').value !== "") {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="">E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                } else {
                    let htmlString = '<div class="alert bg-success-bg text-success-text form__field-error" tabindex="-1" autofocus="" >E-mail exists please enter a different email.</div>';
                    document.querySelector("pop-up .modal__window form .form__field").insertAdjacentHTML("afterend", htmlString);
                }
            }
        }
    });*/

    // set request a quote required fields - ?contact_posted=true
    /* //waitForElm('html.boat-canvas-custom-quote .shopify-section.cc-contact-form .form .form__grid > div select[name="contact[year]"] option[selected]', true).then((elm) => {
    $q('html.boat-canvas-custom-quote .shopify-section.cc-contact-form .form .form__grid > div select[name="contact[year]"] option[selected]').wait(true,(elm) => {
      
      if(document.querySelector("html.boat-canvas-custom-quote") !== null){
          for (var quotefieldDiv of document.querySelectorAll(".shopify-section.cc-contact-form .form .form__grid > div")) {
            let quoteFieldDivLabel = quotefieldDiv.querySelector("label").textContent.toLowerCase();
            let quoteField = quotefieldDiv.querySelector(".input");
            if(quoteField.tagName === 'SELECT'){
              if(quoteFieldDivLabel.indexOf("manufacturer") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              } else if(quoteFieldDivLabel.indexOf("year") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              } else if(quoteFieldDivLabel.indexOf("products in your quote") !== -1){
                createOptionSetRequired(quoteField,quotefieldDiv);
              }
            } else if(quoteField.tagName === 'INPUT'){
              if(quoteFieldDivLabel.indexOf("model") !== -1){
                $q(quotefieldDiv).addClass("is-required");
                quoteField.setAttribute("required",""); 
              }
            }
          }
      }
    });*/

    // access shadow root to change font family and color on to shopify-installments-modal eligibility-approval text 
    // since it uses system font making it hard to read
    //waitForElm('html.is-products shopify-installments-modal', true).then((elm) => {
    $q('html.is-products shopify-installments-modal').wait(true,(elm) => {

        // Access the shadow host element
        let shadowHost = document.querySelector('shopify-installments-modal');
        // Access the shadow root
        let shadowRoot = shadowHost.shadowRoot;
        // Select an element within the shadow root
        let eligibilityApprovalShadow = shadowRoot.querySelector('#eligibility-approval');
        eligibilityApprovalShadow.style.fontFamily = "Arial";
        eligibilityApprovalShadow.style.color = "#555555";
    });
    /* //waitForElm('html.is-products shopify-payment-terms', true).then((elm) => {
    $q('html.is-products shopify-payment-terms').wait(true,(elm) => {
      
      // Access the shadow host element
      let shadowHost = document.querySelector('shopify-payment-terms');    
      // Access the shadow root
      let shadowRoot = shadowHost.shadowRoot;
      let shadowRoot2 = shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot
      let shopifyInstallmentsCTA = shadowRoot2.querySelector('#shopify-installments-cta');
      shopifyInstallmentsCTA.style.textDecoration = "none";
    });*/

    /*window.addEventListener("load", (event) => {

        //waitForElm('html product-card .card__media.has-custom-product-theme-label', true).then((elm) => {
        $q('html product-card .card__media.has-custom-product-theme-label').wait(true,(elm) => {
        
          $q(document.documentElement).addClass("custom-product-theme-label-loaded");
        });
    });*/

    ///////////////////////////////////////////
    // copy sku text to clipboard

    // select all text for copy to clipboard
    function selectAllForCopy(obj) {

        var text_val = eval(obj);
        text_val.focus();
        text_val.select();
    }

    ///////////////////////////////////////////
    // copy coupon text to clipboard

    function copyShareLinkClipboardAllPages(id) {

        // Get the text field
        var copyText = document.getElementById(id);

        // Select the text field
        copyText.select();
        // Copy the text inside the text field
        document.execCommand("copy");
        // Alert the copied text
        //console.log("Copied the text: " + copyText.value);
    }

    for (var couponLinkInputButton of document.querySelectorAll(".coupon-link-input-button")) {

      // coupon overlay text input
      // copy share-link to clipboard event
      couponLinkInputButton.addEventListener("click",function(e){

          e.preventDefault();
          //console.log("sku-link trigger");

          var selectedItem = this;
          var prevInputID = selectedItem.previousElementSibling.id;
          //console.log(prevInputID);
          copyShareLinkClipboardAllPages(prevInputID);
          $q(selectedItem).addClass("copied");
          setTimeout(function() {
              $q(selectedItem).removeClass("copied");
          }, 1500);

          return false;
      });
    }

    for (var couponLinkInput of document.querySelectorAll(".coupon-link-input")) {
      
      // select all coupon link input[text]
      couponLinkInput.addEventListener("click",function(e){

          e.preventDefault();
          selectAllForCopy(this);
          return false;
      });
    }    
    // END - copy coupon text to clipboard
    //////////////////////////////////////////


  //////////////////////////////////////////////////////////////////////////////////////////
  // fix theme product types not working in chrome
  //waitForElm('#search-bar #product_types #product_types-button', true).then((elm) => {
  $q('#search-bar #product_types #product_types-button').wait(true,(elm) => {
    
    //console.log("search dropdown exists");
    
    document.querySelector("#search-bar #product_types #product_types-button").addEventListener("click", function(){
      //console.log("search dropdown clicked");
      let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
      this.setAttribute("aria-expanded", "true");
      productTypesListBox.setAttribute("aria-hidden", "false");
      productTypesListBox.removeAttribute("hidden");
    });

    var urlString = window.location.search;
    var urlParams = new URLSearchParams(urlString);
    var filterParamValue = urlParams.get('filter.p.product_type');
    var hasSearchProductTypesSearchParam = false;
    var productTypesHiddenInput = document.querySelector("#product_type_input").value;
    if (urlParams.has('filter.p.product_type')) {
        hasSearchProductTypesSearchParam = true;
    }

    let dataValuePT = "";
    for (var productTypeLi of document.querySelectorAll("#search-bar #product_types ul.custom-select__listbox li")) {
      
      productTypeLi.addEventListener("mouseover", function(){
        //console.log("search dropdown clicked");
        $q(this.parentElement.querySelectorAll("li")).removeClass("is-focused");
        $q(this).addClass("is-focused");
      });

      productTypeLi.addEventListener("click", function(){
        //console.log("search dropdown clicked");
        let li = this;
        let dataValue = this.dataset.value;
        //let a = li.querySelector("a");        
        document.querySelector("#product_type_input").value = dataValue;
        //document.querySelector("store-header header").dispatchEvent(new Event("click"));
        let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
		document.querySelector('#product_types #product_types-button').setAttribute("aria-expanded", "false");
        productTypesListBox.setAttribute("aria-hidden", "true");
        productTypesListBox.setAttribute("hidden","");

        for (var ptLI of document.querySelectorAll("#search-bar #product_types ul.custom-select__listbox li")) {
            ptLI.removeAttribute("aria-selected");
        }
        this.setAttribute("aria-selected","true");
        if(dataValue === "") {
          dataValue = "All";
        }
        document.querySelector("#product_types-button span").textContent = dataValue;
      });

      /*if (hasSearchProductTypesSearchParam == true) {
        var dataValue = productTypeLi.dataset.value;
        dataValue.replaceAll("+"," ");
        productTypesHiddenInput.replaceAll("+"," ");        
        if(filterParamValue == dataValue){
          dataValuePT = dataValue;
          //console.log("filterParamValue",filterParamValue);
          //console.log("dataValue",dataValue);
          //console.log("productTypesHiddenInput",productTypesHiddenInput);
         }
      }*/
    }

    //if (hasSearchProductTypesSearchParam == true && dataValuePT !== "") {// filterParamValue
       //document.querySelector('#search-bar #product_types ul.custom-select__listbox li[data-value="' + dataValuePT + '"]').dispatchEvent(new Event("click"));
    //}
    if (hasSearchProductTypesSearchParam == true && filterParamValue !== "") {
      $q(document.documentElement).addClass("has-url-param-product-type-not-empty");
    }

    // close custom select if click outside it
	document.addEventListener("click", function(event) {

    	let targetElement = event.target; // Clicked element
		let customSelect = document.querySelector('#search-bar custom-select.search__product-types');
		if (customSelect && !customSelect.contains(targetElement)) {
            let productTypesListBox = document.querySelector("#search-bar #product_types ul.custom-select__listbox");
			document.querySelector('#product_types #product_types-button').setAttribute("aria-expanded", "false");
            productTypesListBox.setAttribute("aria-hidden", "true");
            productTypesListBox.setAttribute("hidden","");
		}
	});
  });

  //////////////////////////////////////////
  // trigger fancy box when jquery loaded
  //waitForElm('html.jquery-is-loaded', true).then((elm) => {// #cd-size-tips-box #cd-size-diagram #cd-size-diagram-a.fancybox 
  $q('html.q-is-loaded').wait(true,(elm) => {//.jquery-is-loaded

    // move current date into cart page title h1
    if(enableCartCSR == true){

        $q('html.is-cart.is-csr #current-date #current-date-day').wait(true,(elm) => {
            
            if(document.querySelector('#cart-items .cart-empty') == null){

                let date = new Date();
                let formattedDate = date.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
                let currentTime = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
                //document.querySelector("#current-time").setAttribute("data-time",currentTime);
                $q("#current-time").text(currentTime);
                $q("#current-date-day").text(formattedDate);

                // add print contact iinfo to header
                function csrAddress() {

                    var info = [
                        { 
                            "store": "pl",
                            "numberLocal": "727.498.0547",
                            "numberTollFree": "1.866.516.0934"
                        },
                        { 
                            "store": "ofc",
                            "numberLocal": "727.597.4134",
                            "numberTollFree": "1.866.712.5684"
                        },
                        { 
                            "store": "ot",
                            "numberLocal": "727.597.4141",
                            "numberTollFree": "1.866.516.0941"
                        }
                    ];

                    // which store is currently active
                    var activeStore = "ofc";  // example

                    // find matching store object
                    var storeData = info.find(obj => obj.store === activeStore);

                    let html = "";

                    if (storeData) {
                        html = `
                        <div id="print-contact-info" style="display: none;">
                            10820 US 19 North<br>
                            Clearwater, FL 33764 USA<br>
                            Local: ${storeData.numberLocal}<br>
                            Toll-Free: ${storeData.numberTollFree}</p>
                        </div>
                        `;
                        document.querySelector('store-header.header header').insertAdjacentHTML('beforeend', html);
                        //console.log(html);
                    }
                }
                csrAddress();
                $q('#pdf-csr-button').on('click',function(){

                    if($q("#current-date").hasClass('active')){
                        $q("#current-date").removeClass('active');
                    } else {
                        $q("#current-date").addClass('active');
                    }
                });
                $q("#pdf-csr-button").addClass('active');
            }

        });
    }

    $q('html.q-is-loaded #main-content div.youtube').wait(true,(elm) => {
		
		// create screenshot only for building of youtube video on click
		var youtube = document.querySelectorAll("div.youtube");
        //console.log(youtube.length);
		if(youtube.length !== 0){

					//console.log("run youtube video build");						
					//var $homepageVideos = document.getElementById("#homepage-videos");
					//$homepageVideos.style.overflow = "hidden";
					//$homepageVideos.style.maxHeight = 220;
					//https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/default.jpg -   default
					//https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/mqdefault.jpg - medium 
					//https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/hqdefault.jpg - high
					//https://i1.ytimg.com/vi/<insert-youtube-video-id-here>/sddefault.jpg - standard
					
					//var isHome;
					var thumbnailName = "hqdefault";
					var youTubePaddingTop = "";
					var youTubeImgTop = "";
						
					//if($("body.cms-home").length > 0 || $("body.blog-cat-view").length > 0 || $("body.cms-page-view").length > 0 || isCategoryPage || isSearchPage) {
						//thumbnailName = "mqdefault";
					//}
					
					for (var i = 0; i < youtube.length; i++) {
							
						//if(youtube[i].classList.contains("featured-vid")){
							//thumbnailName = "hqdefault";
							youTubePaddingTop = "56.25%";
							youTubeImgTop = "-20%";
						//}
						
						var source = "https://img.youtube.com/vi/"+ youtube[i].dataset.videoUrl +"/"+thumbnailName+".jpg";	
						var image = new Image();
							
						// only add image if does not exist
						if(youtube[i].getAttribute("data-custom-src") && youtube[i].dataset.customSrc != ""){
							source = youtube[i].dataset.customSrc;
							youtube[i].dataset.customSrc = source;
						}	
						
						if(thumbnailName == "hqdefault"){
							youtube[i].style.paddingTop = youTubePaddingTop;
							image.style.top = youTubeImgTop;
						}
						
						image.src = source;
						
						if (navigator.appName == 'Microsoft Internet Explorer' || (navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1)){
							// IE or EDGE
							//image.addEventListener("load", function() {
								youtube[i].appendChild(image);
							//});
						}  else {
							image.addEventListener("load", function() {
								youtube[i].appendChild(image);
							}(i));
						}
						
						youtube[i].addEventListener( "click", function() {
							
							var iframe = document.createElement("iframe");
							iframe.setAttribute("width", "100%");
							iframe.setAttribute("height", "100%");
							iframe.setAttribute("frameborder", "0");
							iframe.setAttribute("allowfullscreen", "");
							iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
							iframe.setAttribute("src", "https://www.youtube.com/embed/"+ this.dataset.videoUrl +"?autoplay=1");
							//  +"?rel=0&showinfo=0&autoplay=1&hd=1"
							this.innerHTML = "";
							this.appendChild(iframe);
							//this.prepend(iframe);
						});	
					};
		}
	});

    //console.log('jquery and q loaded');
    //console.log(typeof jQuery.fn.fancybox !== "undefined");
 
    //jonnyZoom('.zoom-origin:not(.tooltip-trigger):not(.preview):not(.simple-modal):not(.default-modal):not(.simple-modal-no-arrows):not(.gallery-modal)', { nav: 'off' }, 'zoomOrigin');
    //jonnyZoom('.zoom-origin.simple-modal', { thumbs: 'off' }, 'zoomOriginSimpleModal');
    //jonnyZoom('.zoom-origin.gallery-modal', { loopMode: 'bounded' }, 'zoomOriginGalleryModal');
    //jonnyZoom('.zoom-origin.simple-modal-no-arrows.modal-has-download:not(.modal-popup)', { nav: 'off', thumbs: 'off' }, 'zoomOrigin');

    // only run on is-builder page]
	if($q("html.is-builder").length > 0) {

        const jonnyzoomBuilder = jonnyZoom('.cd-builder-ready', { triggerSelector: '.jonnyzoom-builder' });
        //jonnyZoom('.cd-builder-ready', {  }, 'jonnyzoomBuilder');
        //const jonnyzoomBuilder = jonnyZoom('.cd-builder-ready',{ targetSelector: '.jonnyzoom-builder' });

        const jonnyzoomFabricPicker = jonnyZoom('#fp-slider', { loopMode: 'bounded', nav: 'on', thumbs: 'on', thumbsOnTouchHide: false });// wrap

        //console.log("html.is-builder");

        // convert fancybox to jonnyZoom
        //jonnyZoom('#gallery1', { thumbs: 'off' }, 'galleryA');
        //jonnyZoom('#gallery2', { loopMode: 'bounded' }, 'galleryB'); 
        
        //jonnyZoom('.jonnyzoom-share-link', { }, 'jonnyZoomShareLink');
        //jonnyZoom('.share-link-internal-summary', { }, 'shareLinkInternalSummary');
        //jonnyZoom('.simple-modal-no-arrows', { }, 'simpleModalNoArrows');
        //jonnyZoom('.gallery-modal-2', { }, 'galleryModal2');

    } else {
        
        const jonnyzoom = jonnyZoom({ triggerSelector: '.jonnyzoom' });

        //jonnyZoom({ triggerSelector: '.jonnyzoom', nav: 'off', thumbs: 'off' }, 'jonnyzoom');    
        //jonnyZoom({ targetSelector: '.jonnyzoom' }, 'jonnyzoomSite');
        //const zoom = jonnyZoom('.jonnyzoom', { });

        // No parent needed, global scan:
        //const zoom = jonnyZoom({ triggerSelector: '.jonnyzoom' });
        // Back-compat name still works:
        //const zoom2 = jonnyZoom({ targetSelector: '.jonnyzoom' });
        // With an explicit parent (still supported):
        //const zoom3 = jonnyZoom('#gallery1', { triggerSelector: 'a[data-zoom]' });
        // or pass global window var
        //jonnyZoom('#gallery1', {  }, 'jonnyzoom');
    }

    /* if(jQuery.fn.fancybox){

        //console.log('fancybox loaded');

					//console.log($q('.fancybox:not(.tooltip-trigger):not(.preview)').length);

					jQuery('.fancybox:not(.tooltip-trigger):not(.preview):not(.simple-modal):not(.default-modal):not(.simple-modal-no-arrows):not(.gallery-modal)').fancybox({
					    //animationEffect: "zoom",
						//transitionEffect: "zoom-in-out",
						//protect: true,
						////loop: true,
						//caption: function (instance, item) {
							////console.log($q(this).attr("title"));
							//var title = $q(this).attr("title");
							////	if ($q(this).next('figcaption').length > 0) {
							////		title = $q(this).next('figcaption').html();
							////	}
							//return title;
						//},
						//image: {
						//	preload: true
						//}
                        clickSlide: "close",
                        clickOutside: "close",
                        hash: false,
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							"thumbs",
							"close"
						],
						thumbs: {
							autoStart: true, // Display thumbnails on opening
							hideOnClose: false, // Hide thumbnail grid when closing animation starts
							//parentEl: ".fancybox-container", // Container is injected into this element
							axis: "y" // Vertical (y) or horizontal (x) scrolling
						},
						autoFocus: false,
						afterShow: function(){
							$q("html").addClass("fancybox-open");
						},
						afterClose: function(){
							$q("html").removeClass("fancybox-open");
						}
					});

				    ///* jQuery().fancybox({
					//	selector : '.fancybox:not(.tooltip-trigger):not(.preview):not(.simple-modal)',
					//	parentEl: "#main-content",
					//	autoFocus: false,
                    //    hash: false,
					//});


					jQuery().fancybox({
						selector : '.fancybox.simple-modal',
						parentEl: "#main-content",
						arrows: true,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
                        hash: false,
                        clickSlide: "close",
                        clickOutside: "close",
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							//"thumbs",
							"close"
						], 
						beforeShow: function(){
							jQuery("html").addClass("simple-modal");
						},
						beforeClose: function(){
							jQuery("html").removeClass("simple-modal");
						}
					});


					jQuery().fancybox({
						selector : '.fancybox.gallery-modal',
						parentEl: "#main-content",
						arrows: true,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
                        hash: false,
                        clickSlide: "close",
                        clickOutside: "close",
						thumbs: {
							autoStart: false, // Display thumbnails on opening
							hideOnClose: true, // Hide thumbnail grid when closing animation starts
							//parentEl: ".fancybox-container", // Container is injected into this element
							axis: "y" // Vertical (y) or horizontal (x) scrolling
						},
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"download",
							"thumbs",
							"close"
						], 
						beforeShow: function(){
							$q("html").addClass("gallery-modal");
						},
						beforeClose: function(){
							$q("html").removeClass("gallery-modal");
						},
						afterClose: function(){

						},
					});

					jQuery().fancybox({
						selector : '.fancybox.simple-modal-no-arrows.modal-has-download:not(.modal-popup)',
						parentEl: "#main-content",
						arrows: false,
						toolbar: true,
						vertical: false,
						loop: false,
						autoFocus: false,
						groupAttr: false,
                        hash: false,
						touch: false,//hasTouch,
                        clickSlide: "close",
                        clickOutside: "close",
						buttons: [
							//"zoom",
							//"share",
							//"slideShow",
							//"fullScreen",
							//"thumbs",
							//"download",
							"close"
						],
						beforeShow: function(){
							$q("html").addClass("simple-modal-no-arrows");
						},
						beforeClose: function(){
							$q("html").removeClass("simple-modal-no-arrows");
						}
					});

					// jQuery().fancybox({
					//	selector : '.fancybox.default-modal',
					//	parentEl: ".page-wrapper",
					//	arrows: true,
					//	toolbar: true,
					//	vertical: false,
					//	loop: false,
					//	autoFocus: false,
                    //    hash: false,
                    //    clickSlide: "close",
                    //    clickOutside: "close",
					//	buttons: [
					//		//"zoom",
					//		//"share",
					//		//"slideShow",
					//		//"fullScreen",
					//		//"download",
					//		//"thumbs",
					//		"close"
					//	], 
					//	beforeShow: function(){
					//		$q("html").addClass("default-modal");
					//	},
					//	beforeClose: function(){
					//		$q("html").removeClass("default-modal");
					//	}
					//}//); 


					// only run on is-builder page]
					if($q("html.is-builder").length > 0) {

						//jQuery().fancybox({
							//selector : '.fancybox.tooltip-trigger', 
							//type: "inline", 
							//parent: "#pb-box", 
							//arrows: false,
							//toolbar: false,
							//touch: false,
							//vertical: false,
							//autoFocus: false,
							//width: 400,
							//height: 400,
							//maxWidth: "40%",
							//maxHeight: "40%",
                            //hash: false,
                            //clickSlide: "close",
                            //clickOutside: "close",
							//beforeShow: function(){
							//	$q("html").addClass("tooltip-modal");
							//},
							//beforeClose: function(){
							//	$q("html").removeClass("tooltip-modal").addClass("was-tooltip-step-1");
							//}////,
							////baseClass: "fancybox-tooltip"
						//});

                        jQuery().fancybox({
                            selector : '.fancybox-share-link',
                            parentEl: "#main-content",
                            //buttons : ['close'],
                            loop: false,
                            toolbar: false,
                            arrows: false,
                            touch: false,
                            vertical: false,
                            autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
                            beforeShow: function(){
                                $q("html").addClass("share-link-open");
                            },
                            afterClose: function() {
                                $q("html").removeClass("share-link-open");
                            }
                        });

					  	jQuery().fancybox({
							selector : '.fancybox-share-link-internal-summary',
							parentEl: "#main-content",
							//buttons : ['close'],
							loop: false,
							toolbar: false,
							arrows: false,
							touch: false,
							vertical: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							beforeShow: function(){
								$q("html").addClass("share-link-open");
							},
							afterClose: function() {
								$q("html").removeClass("share-link-open");
							}
						});

						jQuery().fancybox({
							selector : '.fancybox.simple-modal-no-arrows',
							parentEl: "#main-content",
							arrows: false,
							toolbar: true,
							vertical: false,
							loop: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							buttons: [
								//"zoom",
								//"share",
								//"slideShow",
								//"fullScreen",
								//"download",
								//"thumbs",
								"close"
							], 
							beforeShow: function(){
								$q("html").addClass("simple-modal-no-arrows");
							},
							beforeClose: function(){
								$q("html").removeClass("simple-modal-no-arrows");
							}
						});

						jQuery().fancybox({
							selector : '.fancybox.gallery-modal-2',
							parentEl: "#main-content",
							arrows: true,
							toolbar: true,
							vertical: false,
							loop: false,
							autoFocus: false,
                            hash: false,
                            clickSlide: "close",
                            clickOutside: "close",
							thumbs: {
								autoStart: false, // Display thumbnails on opening
								hideOnClose: true, // Hide thumbnail grid when closing animation starts
								//parentEl: ".fancybox-container", // Container is injected into this element
								axis: "y" // Vertical (y) or horizontal (x) scrolling
							},
							buttons: [
								//"zoom",
								//"share",
								//"slideShow",
								//"fullScreen",
								//"download",
								"thumbs",
								"close"
							], 
							beforeShow: function(){
								$q("html").addClass("gallery-modal");
								if(document.querySelector("html.desktop") !== null){
									document.querySelector(".fancybox-button.fancybox-button--thumbs").dispatchEvent(new Event("click"));
								}
							},
							beforeClose: function(){
								$q("html").removeClass("gallery-modal");
							},
							afterClose: function(){
								if(document.querySelector("html.desktop .fancybox-show-thumbs") !== null){
									document.querySelector(".fancybox-button.fancybox-button--thumbs").dispatchEvent(new Event("click"));
								}
							},
						});

						// if(jQuery("body.is-builder-pillow").length > 0) {

						//	jQuery().fancybox({
						//		selector : '.fancybox.fancybox-video',
						//		parentEl: "#product-builder",
						//		//buttons : ['close'],
						//		toolbar: false,
						//		arrows: false,
						//		touch: false,
						//		vertical: false,
						//		autoFocus: false,
                        //       hash: false,
						//		afterClose: function() {
						//			$q("#measure-pillow-youtube-video iframe").remove();
						//			$q("#measure-pillow-youtube-video .youtube").append('<div class="play-button"></div><img src="/media/theme/Refueledinc/builders/images/how-to-measure-pillows.jpg">');
						//		}
						//	});
						//} 
					}

      } else {
		//	if(window.console) { console.log("no-fancybox"); }
      } */
    

    // force disabled toggle state if qty above 1 or is 1
    $q('html.q-is-loaded.is-products product-form .product-info__add-to-cart .qty-input__input.input').wait(true,(elm) => {

        // add minmax validation ux
        if(enableQtyMinMaxCheck == true){

            $q('html.q-is-loaded.is-products .product-info__add-to-cart quantity-input [data-minmax]').wait(true,(elm) => {

                ////////////////////////////////////////////////////////////////
                //Attach min-quantity validation using event delegation on parent containers.
                // Each .quantity-input parent contains an input with a data-minmax attribute.
                function attachMinQuantityValidationDelegated(parentSelector = '.product-info__add-to-cart') {

                    // only run if qty input data minmax is not empty
                    let productQtyMinInput = document.querySelector('.product-info__add-to-cart input[name="quantity"][data-minmax]');
                    let productQtyMinData = productQtyMinInput.dataset.minmax;

                    if(enableQtyMinMaxCheckEvents == true){

                        if(productQtyMinInput !== null && productQtyMinData !== ""){

                            let minQtyMessageBox = document.querySelector('.product-info .min-qty-message.product-status-message');
                            minQtyMessageBox.querySelector('span').textContent = productQtyMinData;
                            minQtyMessageBox.classList.add('show');

                            document.querySelectorAll(parentSelector).forEach(parent => {

                                parent.addEventListener('change', (e) => {

                                    const input = e.target.closest('.qty-input__input.input');
                                    if (!input) return;

                                    const minQty = parseFloat(input.dataset.minmax) || 1;
                                    const currentValue = parseFloat(input.value) || 0;

                                    if (currentValue < minQty) {
                                        input.value = minQty;
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').setAttribute('disabled',true);
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').attr('disabled',true);
                                        //console.log(`Adjusted quantity to minimum of ${minQty}`);                                    
                                    } else {
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').removeAttribute('disabled');
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').remove('disabled');
                                        //console.log(`allow quantity to minimum of ${minQty}`);
                                    }

                                    if(parseFloat(input.value) <= parseFloat(input.dataset.minmax)){//parseFloat(input.dataset.minmax) == parseFloat(input.value) || 
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').setAttribute('disabled',true);
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').attr('disabled',true);
                                        //console.log("minqty equal or less");
                                    }
                                });

                                // Optional: also validate on blur
                                parent.addEventListener('blur', (e) => {

                                    const input = e.target.closest('.qty-input__input.input');
                                    if (!input) return;

                                    const minQty = parseFloat(input.dataset.minmax) || 1;
                                    const currentValue = parseFloat(input.value) || 0;

                                    if (currentValue < minQty) {
                                        input.value = minQty;
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').setAttribute('disabled',true);
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').attr('disabled',true);
                                        //console.log(`Adjusted quantity to minimum of ${minQty}`);
                                    } else {
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').removeAttribute('disabled');
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').removeAttr('disabled');
                                        //console.log(`allow quantity to minimum of ${minQty}`);
                                    }

                                    if(parseFloat(input.value) <= parseFloat(input.dataset.minmax)){//parseFloat(input.dataset.minmax) == parseFloat(input.value) ||
                                        input.parentElement.querySelector('.qty-input__btn.btn.btn--minus').setAttribute('disabled',true); 
                                        //$q(input).parent().find('.qty-input__btn.btn.btn--minus').attr('disabled',true);
                                        //console.log("minqty equal or less");
                                    }
                                }, true); // useCapture=true ensures blur bubbles properly
                            });
                        }

                    } else {

                        $q('html.q-is-loaded.is-products .product-info__add-to-cart quantity-input [data-minmax]').wait(true,(elm) => {

                            // only run if qty input data minmax is not empty
                            let productQtyMinInput = document.querySelector('.product-info__add-to-cart input[name="quantity"][data-minmax]');
                            let productQtyMinData = productQtyMinInput.dataset.minmax;
                            if(productQtyMinInput !== null && productQtyMinData !== ""){
                                let minQtyMessageBox = document.querySelector('.product-info .min-qty-message.product-status-message');
                                minQtyMessageBox.querySelector('span').textContent = productQtyMinData;
                                minQtyMessageBox.classList.add('show');
                            }
                        });

                        $q('html.q-is-loaded.is-products .product-info__add-to-cart quantity-input [data-minmax=""]').wait(true,(elm) => {                        

                            $q('html.is-products product-form .product-info__add-to-cart .qty-input__input.input').on('input',function(event){

                                let selectedItem = this;
                                let t = event.target;
                                if (selectedItem && t && (t.closest(".qty-input__input.input"))) {
                                    //console.log('input qty');
                                    let inputValue = parseInt(t.value);
                                    if(inputValue > 1){
                                        t.parentElement.querySelector('.qty-input__btn.btn.btn--minus').removeAttribute('disabled');
                                        //console.log('inputValue > 1', inputValue);
                                    } else if(inputValue == 1) {
                                        t.parentElement.querySelector('.qty-input__btn.btn.btn--minus').setAttribute('disabled',"");
                                        //console.log('inputValue == 1', inputValue);
                                    }
                                }
                            });

                        });
                    }
                }

                // Initialize once
                attachMinQuantityValidationDelegated();
                
            });
        }
    });

  }); // END - q loaded

  ///////////////////////////////////////////
  // listen and check if jquery is laoded
  let jqueryCheckInterval = setInterval(function() {
    if (typeof jQuery !== 'undefined') {
      //console.log('jQuery is loaded.');
      clearInterval(jqueryCheckInterval);
      $q(document.documentElement).addClass("jquery-is-loaded");
    } else {
      //console.log('jQuery is not yet loaded, checking again...');
    }
  }, 200);

  let queryCheckInterval = setInterval(function() {
    if (typeof querySelector !== 'undefined') {
      //console.log('querySelector is loaded.');
      clearInterval(queryCheckInterval);
      $q(document.documentElement).addClass("q-is-loaded");
    } else {
      //console.log('$q() is not yet loaded, checking again...');
    }
  }, 200);

  // window-loaded
  window.addEventListener("load", function(){
    $q(document.documentElement).addClass("window-loaded");
  });
  
}); // END - DOM loaded